import { FAQ } from './FAQ';

export * from './FAQ';

export default FAQ;
